// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-k_gY","advertDetailHeaderPrice__value":"c-k_gZ","advertDetailHeaderPrice__label":"c-k_ha"};